import { render, staticRenderFns } from "./FunnelStage.vue?vue&type=template&id=0b21082a&scoped=true&"
import script from "./FunnelStage.vue?vue&type=script&lang=js&"
export * from "./FunnelStage.vue?vue&type=script&lang=js&"
import style0 from "./FunnelStage.vue?vue&type=style&index=0&id=0b21082a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b21082a",
  null
  
)

export default component.exports